import React from "react";
import { Link } from "react-router-dom";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import { all_routes } from "../../router/all_routes";



const ProjectsCommonHeader: React.FC = () => {

  return (
    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
      <div className="my-auto mb-2">
        <h2 className="mb-1">Project Details</h2>
        <nav>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <Link to={all_routes.adminDashboard}>
                <i className="ti ti-smart-home" />
              </Link>
            </li>
            <li className="breadcrumb-item">Projects</li>
            <li className="breadcrumb-item active" aria-current="page">
              Details
            </li>
          </ol>
        </nav>
      </div>

      <div className="d-flex my-xl-auto right-content align-items-center flex-wrap gap-2">
        <div className="mb-2" title="Back Button">
          <Link className="btn btn-info" to={all_routes.projectsList}>
            <i className="ti ti-arrow-back me-2" />
            Go Back
          </Link>

        </div>

        <div className="head-icons ms-2">
          <CollapseHeader />
        </div>
      </div>
    </div>
  );
};

export default ProjectsCommonHeader;
